import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService, SystemCodeService } from '../../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController, PickerController } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi

import { PickerOptions } from "@ionic/core";

import { NewPageSelectComponent } from '../../new-page-select/new-page-select.component';
import { LazyLoadingSelectComponent } from '../../lazy-loading-select/lazy-loading-select.component';
import { TranslateService } from '@ngx-translate/core';
import { SystemCodeMap } from '../../../configs/system-code-map';
import { CorpSelectComponent } from '../../corp-select/corp-select.component';
import { OrgCascaderComponent } from '../../org-cascader/org-cascader.component';
import { ClassificationFormSelectComponent } from '../../classification-form-select/classification-form-select.component';

@Component({
	selector: 'incident-filter-modal',
	templateUrl: './incident-filter-modal.component.html',
	styleUrls: ['./incident-filter-modal.component.scss'],
})
export class IncidentFilterModalComponent implements OnInit {
  query;
	// 默认筛选条件
  startTime = null;
  endTime = null;
  currentDateString = new Date().toISOString();

  isInquiry;
  isInquiryMultiSelect;
  isInvestigation;
  isCorrective;
  isCorrectiveMultiSelect;

  taskStatusList = [];
  inquiryStatusList = [];
  investigationStatusList = [];
  correctiveStatusList = [];
  correctiveMultiSelectStatusList = [];
  premisesList = [];
  incidentTypeList = [];
  locationTreeList = [];
  peopleList = [];
  hazardTypeList = [];
  injuredBodyPartList = [];
  unsafeConditionList = [];
  unsafeBehaviorList = [];
  violationList = [];
  kpiTypeList = [];
  trueAndFalseList = [
    {
      text: this.translateService.instant('shared_components.filter_modals.yes'),
      value: 1,
    },
    {
      text: this.translateService.instant('shared_components.filter_modals.no'),
      value: 2,
    },
  ];

  display_field = 'code_desc_en';

	constructor(
		public dataService: DataService,
		public appService: AppService,
		public router: Router,
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalController: ModalController,
    public localStorageService: LocalStorageService,
    public pickerController: PickerController,
    private translateService: TranslateService,
    private systemCode: SystemCodeService,
  ) {
		let params = this.navParams.data;
    this.query = params.query;
    this.isInquiry = params.isInquiry;
    this.isInquiryMultiSelect = params.isInquiryMultiSelect;
    this.isInvestigation = params.isInvestigation;
    this.isCorrective = params.isCorrective;
    this.isCorrectiveMultiSelect = params.isCorrectiveMultiSelect;
	}

	ngOnInit() {
    // 筛选框使用
    let lang = localStorage.getItem("APP_LANG");
    switch (lang) {
      case 'zh_CN':
        this.display_field = 'code_desc_zh';
        break;
      case 'en_US':
        this.display_field = 'code_desc_en';
        break;
      case 'zh_TW':
        this.display_field = 'code_desc_tr';
        break;
      case 'vi':
        this.display_field = 'code_desc_vi';
        break;
      case 'km':
        this.display_field = 'code_desc_km';
        break;
      case 'th':
        this.display_field = 'code_desc_th';
        break;
      case 'lo':
        this.display_field = 'code_desc_lo';
        break;
      default:
        this.display_field = 'code_desc_en';
        break;
    }
		// 设置标题
		document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
    this.systemCode.loadCodes([
      SystemCodeMap.capaSourceCategoryList,
      SystemCodeMap.accidentCategoryList,
      SystemCodeMap.incidentQualityCategoryList,
    ]).subscribe(() => {});
    // 获取状态code
    if (this.isInquiry) {
      this.getInquiryStatusList();
      this.getPremisesList();
    } else if (this.isInvestigation) {
      this.getInvestigationStatusList();
      this.getPremisesList();
      this.getHazardTypeList();
      this.getInjuredBodyPartList();
      this.getUnsafeConditionList();
      this.getUnsafeBehaviorList();
    } else if (this.isCorrective) {
      this.getCorrectiveStatusList();
      this.getViolationList();
      this.getKpiTypeList();
    }
	}

  // 获取事故查询状态
  async getInquiryStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_PL1').subscribe(res => {
        const { taskStatus } = SystemCodeMap;
        if (res && res.STATUS === 0) {
          this.inquiryStatusList = res.DATA[0].childCodes.filter(value => {
            return value.code == '_SYS_PL1_B' ||
              value.code == '_SYS_PL1_C' ||
              value.code == '_SYS_PL1_D' ||
              value.code == '_SYS_PL1_6' ||
              value.code == '_SYS_PL1_E' ||
              value.code == '_SYS_PL1_7';
          });
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取事故调查状态
  async getInvestigationStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_PL1').subscribe(res => {
        const { taskStatus } = SystemCodeMap;
        if (res && res.STATUS === 0) {
          this.investigationStatusList = res.DATA[0].childCodes.filter(value => {
            return value.code === taskStatus.inProgress ||
              value.code === taskStatus.signing ||
              value.code === taskStatus.caseClosed;
          });
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取事故整改状态
  async getCorrectiveStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_PL1').subscribe(res => {
        const { taskStatus } = SystemCodeMap;
        if (res && res.STATUS === 0) {
          this.correctiveStatusList = res.DATA[0].childCodes.filter(value => {
            return value.code !== taskStatus.completed &&
              value.code !== taskStatus.pending &&
              value.code !== taskStatus.draft &&
              value.code !== taskStatus.signed &&
              value.code !== taskStatus.unsigned &&
              value.code !== taskStatus.cancelled &&
              value.code !== taskStatus.reporting &&
              value.code !== taskStatus.reviewing &&
              value.code !== taskStatus.underInvestigation &&
              value.code !== taskStatus.underImprovement &&
              value.code !== taskStatus.waiting &&
              value.code !== taskStatus.overdue &&
              value.code !== taskStatus.assigning && 
              value.code !== taskStatus.review &&
              value.code !== taskStatus.finalReview;
          });
          this.correctiveMultiSelectStatusList = res.DATA[0].childCodes.filter(value => {
            return value.code === taskStatus.inProgress ||
              value.code === taskStatus.verifying ||
              value.code === taskStatus.caseClosed;
          });
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取地点范围
  async getPremisesList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_WH_11').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.premisesList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取灾害类型
  async getHazardTypeList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_SO_1').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.hazardTypeList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取受伤部位
  async getInjuredBodyPartList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_report_injured_A1').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.injuredBodyPartList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取不安全状况
  async getUnsafeConditionList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_INCIDENT_D3_1').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.unsafeConditionList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取不安全行为
  async getUnsafeBehaviorList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_INCIDENT_D3_2').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.unsafeBehaviorList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取违法事项
  async getViolationList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_INCIDENT_DF').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.violationList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取评估方式
  async getKpiTypeList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_R3').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.kpiTypeList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

	// 重置条件
	resetSearchFilters() {
    Object.keys(this.query).forEach((item, index) => {
      this.query[item] = null;
    });
	}

	cancel() {
		this.modalController.dismiss();
	}

	confirm() {
		this.modalController.dismiss({ query: this.query });
  }
  
  // ==================================Method===========================================

  // 更新开始时间格式
	changeStartTimeFormat(event) {
		let selectedDate = event.detail.value;
		if (selectedDate) {
      if (this.endTime && new Date(selectedDate).getTime() - new Date(this.endTime).getTime() > 0) {
        this.appService.toastTip(this.translateService.instant('shared_components.filter_modals.start_time_not_lg_end_time'), true);
      } else {
        this.startTime = new Date(selectedDate).toISOString();
      }
		}
	}
  // 更新结束时间格式
	changeEndTimeFormat(event) {
		let selectedDate = event.detail.value;
		if (selectedDate) {
      if (this.startTime && new Date(selectedDate).getTime() - new Date(this.startTime).getTime() < 0) {
        this.appService.toastTip(this.translateService.instant('shared_components.filter_modals.end_time_not_lg_start_time'), true);
      } else {
        this.endTime = new Date(selectedDate).toISOString();
      }
		}
  }

  // 将查询到的code转化为下拉组件可以识别的形式
  getOptionList(list) {
    let options = [];
		list.forEach(item => {
      let lang = localStorage.getItem("APP_LANG");
      switch (lang) {
        case 'zh_CN':
          options.push({ text: item.code_desc_zh, value: item.code });
          break;
        case 'en_US':
          options.push({ text: item.code_desc_en, value: item.code });
          break;
        case 'zh_TW':
          options.push({ text: item.code_desc_tr, value: item.code });
          break;
        case 'vi':
          options.push({ text: item.code_desc_vi, value: item.code });
          break;
        case 'km':
          options.push({ text: item.code_desc_km, value: item.code });
          break;
        case 'th':
          options.push({ text: item.code_desc_th, value: item.code });
          break;
        case 'lo':
          options.push({ text: item.code_desc_lo, value: item.code });
          break;
        default:
          options.push({ text: item.code_desc_en, value: item.code });
          break;
      }
		});
		return options;
  }

  getTranslateCode(str) {
    let trans = '';
    if (str) {
      const codes = str.split(',');
      codes.forEach((code, index) => {
        trans += this.translateService.instant(code);
        if (index !== codes.length - 1) {
          trans += ',';
        }
      });
    }
    return trans;
  }

  // 选择状态下拉
  private async openMultiStatusModal(statusList: any[]) {
    history.pushState(null, null, document.URL);
    const statusModal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant(this.isCorrective ? 'shared_components.filter_modals.incident_schedule' : 'shared_components.common.status'),
        placeholderMessage: this.translateService.instant(this.isCorrective ? 'shared_components.filter_modals.incident_schedule' : 'shared_components.common.status'),
        originalOptionList: statusList,
        displayField: this.display_field,
        valueField: 'code',
        multiSelect: true,
        needFilterSearch: false,
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.status ? String(this.query.status).split(',') : [],
      },
      showBackdrop: true,
      backdropDismiss: true
    });

    statusModal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (Array.isArray(res.data)) {
        this.query.status = res.data.length > 0 ? res.data.join(',') : null;
      }
    });
    return await statusModal.present();
  }

  translateStatusCodes(status: string, translationList: any[]): string {
    if (!status) return '';
    return String(status).split(',')
      .map(code => this.translateCode(code, translationList))
      .filter(name => name)
      .join(', ');
  }

  translateCode(code: string, translationList: any[]): string {
    const item = translationList.find(status => status.code === code);
    if (!item) return '';
    switch (this.localStorageService.getStore('APP_LANG')) {
      case 'zh_CN': return item.code_desc_zh || item.code_desc_en;
      case 'zh_TW': return item.code_desc_tr || item.code_desc_en;
      case 'vi': return item.code_desc_vi || item.code_desc_en;
      case 'km': return item.code_desc_km || item.code_desc_en;
      case 'th': return item.code_desc_th || item.code_desc_en;
      case 'lo': return item.code_desc_lo || item.code_desc_en;
      default: return item.code_desc_en;
    }
  }

  async selectTaskStatus() {
    if (this.isInquiryMultiSelect) {
      return this.openMultiStatusModal(this.inquiryStatusList);
    }
    if (this.isCorrectiveMultiSelect) {
      return this.openMultiStatusModal(this.correctiveMultiSelectStatusList);
    }

    if (this.isInquiry) {
      this.taskStatusList = this.inquiryStatusList;
    } else if (this.isInvestigation) {
      this.taskStatusList = this.investigationStatusList;
    } else if (this.isCorrective) {
      this.taskStatusList = this.correctiveStatusList;
    }
    let i = 0;
    if (this.query.status) {
      this.taskStatusList.forEach((res, index) =>{
        if (res.code === this.query.status) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.status = value.taskStatus.value;
          }
        }
      ],
      columns: [
        {
          name: 'taskStatus',
          options: this.getOptionList(this.taskStatusList),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 选择地点范围
  async selectPremises() {
    let i = 0;
    if (this.query.facility) {
      this.premisesList.forEach((res, index) =>{
        if (res.code === this.query.facility) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.facility = value.premisesObj.value;
            if (value.premisesObj.value == '_SYS_WH_11_1') {
              this.query.spaceDTO = null;
            } else {
              this.query.incidentLocation = null;
            }
          }
        }
      ],
      columns: [
        {
          name: 'premisesObj',
          options: this.getOptionList(this.premisesList),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  async selectIncidentType() {
    this.dataService.incidentCategoryGroupList(null).subscribe(async res => {
      if (!res || res.STATUS !== 0) {
        this.appService.toastTip(res && res.MSG, false);
        return;
      }
      const list: any[] = res.DATA || [];
      const optionList = list.map(group => ({
        label: this.systemCode.translate(group.code),
        value: group.code,
        code: group.code,
        childSpace: (group.child || []).map(item => ({
          label: this.systemCode.translate(item.code),
          value: item.code,
          code: item.code,
          sourceCategory: group.code,
          childSpace: [],
        })),
      }));
      if (optionList.length === 0) {
        return;
      }
      history.pushState(null, null, document.URL);
      const modal = await this.modalController.create({
        component: ClassificationFormSelectComponent,
        componentProps: {
          pageTitle: 'shared_components.filter_modals.incident_category',
          placeholderMessage: 'shared_components.filter_modals.incident_category',
          optionList: optionList,
          selected: this.query.incidentCategory ? { value: this.query.incidentCategory } : null,
          returnSpaceTree: false,
        },
        showBackdrop: true,
        backdropDismiss: true
      });
      modal.onDidDismiss().then(dismissRes => {
        document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
        if (dd.env.platform !== 'notInDingTalk') {
          dd.biz.navigation.setTitle({
            title: this.translateService.instant('shared_components.common.filter')
          });
        }
        if (dismissRes.data) {
          this.query.incidentCategoryRoot = dismissRes.data.sourceCategory;
          this.query.incidentCategory = dismissRes.data.value;
        }
      });
      await modal.present();
    });
  }

  // 选择组织架构
  async selectOrg() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: OrgCascaderComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.incident_organization'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.incident_organization'),
        selected: this.query.organization,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.organization = res.data;
      }
    });
    return await modal.present();
  }

  // 获取场内地点树
  async getLocationTreeList(id): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getSpaceOfOrgId(id).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.locationTreeList = res.DATA;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }
  async selectLocation() {
    await this.getLocationTreeList(this.query.organization.id);
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: CorpSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.incident_location'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.incident_location'),
        originalOptionList: this.locationTreeList,
        selected: this.query.spaceDTO,
        showInvalid: true
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.spaceDTO = res.data;
      }
    });
    return await modal.present();
  }

  // 获取层级的地点名称
  getLocationLevelName(space) {
    let spaceName = '';
    if (space && this.locationTreeList) {
      const namesPath = this.findNodePathById(this.locationTreeList, space.id);
      spaceName = (namesPath && namesPath.length) > 0 ? namesPath.join(' / ') : '';
    }
    return spaceName;
  }
  findNodePathById(tree, targetId, names = []) {
    // 遍历当前层级的每个节点
    for (const node of tree) {
      // 将当前节点的名字添加到路径名称数组中
      names.push(node.spaceName);
      // 如果当前节点的ID匹配目标ID，则返回路径名称数组
      if (node.id === targetId) {
        return names;
      }
      // 如果当前节点有子节点，则递归查找子树
      if (node.childSpace && node.childSpace.length > 0) {
        // 递归调用，传递当前节点的子树、目标ID以及当前路径
        const foundNames = this.findNodePathById(node.childSpace, targetId, names.slice());
        // 如果在子树中找到了目标ID，则返回找到的名称路径，否则回溯
        if (foundNames) {
          return foundNames;
        }
      }
      // 当前节点不是目标节点且其子节点也没有找到目标ID，从路径中移除当前节点的名字，进行回溯
      names.pop();
    }
    // 如果遍历完当前层级仍未找到目标ID，则返回null
    return null;
  }

  // 选择通报人
  async selectInformant() {
      history.pushState(null, null, document.URL);
      const modal = await this.modalController.create({
        component: LazyLoadingSelectComponent,
        componentProps: {
          pageTitle: this.translateService.instant('shared_components.filter_modals.incident_informant'),
          placeholderMessage: 'shared_components.filter_modals.incident_informant',
          originalOptionList: [],
          displayField: ['code', 'full_name'],
          valueField: '$self',
          multiSelect: false,
          format: '[$1] $2',
          cancelText: 'common.cancel',
          confirmText: 'common.confirm',
          selected: this.query.createdBy,
          searchData: [],
          isStaff: true,
        },
        showBackdrop: true,
        backdropDismiss: true
      });
      modal.onDidDismiss().then(res => {
        // 设置标题
        document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
        if (dd.env.platform !== 'notInDingTalk') {
          dd.biz.navigation.setTitle({
            title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
          });
        }
        // 赋值
        if (res.data) {
          this.query.createdBy = res.data;
        }
      });
      return await modal.present();
  }
  
  // 选择负责人
  async selectResponsiblePerson() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: LazyLoadingSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.responsible_person'),
        placeholderMessage: 'shared_components.common.responsible_person',
        originalOptionList: [],
        displayField: ['code', 'full_name'],
        valueField: '$self',
        multiSelect: false,
        format: '[$1] $2',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.responsiblePerson,
        searchData: [],
        isStaff: true,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.responsiblePerson = res.data;
      }
    });
    return await modal.present();
  }

  // 选择灾害类型
  async selectHazardType() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.hazard_type'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.hazard_type'),
        originalOptionList: this.hazardTypeList,
        displayField: this.display_field,
        valueField: 'code',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.hazardType,
        isOrg: true,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.hazardType = res.data;
      }
    });
    return await modal.present();
  }

  // 选择受伤部位
  async selectInjuredBodyPart() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.poba'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.poba'),
        originalOptionList: this.injuredBodyPartList,
        displayField: this.display_field,
        valueField: 'code',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.injuredArea,
        isOrg: true,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.injuredArea = res.data;
      }
    });
    return await modal.present();
  }

  // 选择不安全状况
  async selectUnsafeCondition() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.unsafe_condition'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.unsafe_condition'),
        originalOptionList: this.unsafeConditionList,
        displayField: this.display_field,
        valueField: 'code',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.unsafeCondition,
        isOrg: true,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.unsafeCondition = res.data;
      }
    });
    return await modal.present();
  }

  // 选择不安全行为
  async selectUnsafeBehavior() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.unsafe_behavior'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.unsafe_behavior'),
        originalOptionList: this.unsafeBehaviorList,
        displayField: this.display_field,
        valueField: 'code',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.unsafeBehavior,
        isOrg: true,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.unsafeBehavior = res.data;
      }
    });
    return await modal.present();
  }

  // 选择违法事项
  async selectViolation() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.violation_item'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.violation_item'),
        originalOptionList: this.violationList,
        displayField: this.display_field,
        valueField: 'code',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.violation,
        isOrg: true,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.violation = res.data;
      }
    });
    return await modal.present();
  }

  // 评估方式
  async selectKpiType() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.evaluation_method'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.evaluation_method'),
        originalOptionList: this.kpiTypeList,
        displayField: this.display_field,
        valueField: 'code',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.kpiType,
        isOrg: true,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.common.filter') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.kpiType = res.data;
      }
    });
    return await modal.present();
  }

  // 选择是否完成改善
  async selectCorrectiveFinished() {
    let i = 0;
    if (this.query.completeResult) {
      this.trueAndFalseList.forEach((res, index) =>{
        if (res.value === this.query.completeResult) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.completeResult = value.trueAndFalseObj1.value;
          }
        }
      ],
      columns: [
        {
          name: 'trueAndFalseObj1',
          options: JSON.parse(JSON.stringify(this.trueAndFalseList)),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 选择是否完成目标
  async selectTarget() {
    let i = 0;
    if (this.query.isGoalCompleted) {
      this.trueAndFalseList.forEach((res, index) =>{
        if (res.value === this.query.isGoalCompleted) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.isGoalCompleted = value.trueAndFalseObj2.value;
          }
        }
      ],
      columns: [
        {
          name: 'trueAndFalseObj2',
          options: JSON.parse(JSON.stringify(this.trueAndFalseList)),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }
}
